
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { UnsplashImage } from "../../../futurelayer/api/unsplash";
import { ImageControlAndInfo } from "@/futurelayer/images/types";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: {
    TextInput,
    NiceButton,
    Icon
  }
})
export default class FutureLayerImageBrowser extends Vue {
  @Prop({ default: null })
  imageControlData!: ImageControlAndInfo | null;

  limit = 3;

  get displayedImages(): UnsplashImage[] {
    return this.imageControlData?.searchResults.slice(0, this.limit) || [];
  }
}
